export default {
  DRAFT: 'DRAFT',
  AWAITING_SEND: 'AWAITING_SEND',
  AWAITING_SIGNATURE: 'AWAITING_SIGNATURE',
  COUNTERSIGN: 'COUNTERSIGN',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED'
}